// key is the locale code from backend, value is the moment and antd locale fileNames which sould be used for dynamic import
export const localeMap: Record<
    string,
    { moment: string; antd: string | null }
> = {
    af: { moment: 'af', antd: null },
    ar: { moment: 'ar', antd: 'ar_EG' },
    'ar-dz': { moment: 'ar-dz', antd: 'ar_EG' },
    'ar-kw': { moment: 'ar-kw', antd: 'ar_EG' },
    'ar-ly': { moment: 'ar-ly', antd: 'ar_EG' },
    'ar-ma': { moment: 'ar-ma', antd: 'ar_EG' },
    'ar-ps': { moment: 'ar-ps', antd: 'ar_EG' },
    'ar-sa': { moment: 'ar-sa', antd: 'ar_EG' },
    'ar-tn': { moment: 'ar-tn', antd: 'ar_EG' },
    az: { moment: 'az', antd: 'az_AZ' },
    be: { moment: 'be', antd: null },
    bg: { moment: 'bg', antd: 'bg_BG' },
    bm: { moment: 'bm', antd: null },
    bn: { moment: 'bn', antd: 'bn_BD' },
    'bn-bd': { moment: 'bn-bd', antd: 'bn_BD' },
    bo: { moment: 'bo', antd: null },
    br: { moment: 'br', antd: null },
    bs: { moment: 'bs', antd: null },
    ca: { moment: 'ca', antd: 'ca_ES' },
    cs: { moment: 'cs', antd: 'cs_CZ' },
    cv: { moment: 'cv', antd: null },
    cy: { moment: 'cy', antd: null },
    da: { moment: 'da', antd: 'da_DK' },
    de: { moment: 'de', antd: 'de_DE' },
    'de-at': { moment: 'de-at', antd: 'de_DE' },
    'de-ch': { moment: 'de-ch', antd: 'de_DE' },
    dv: { moment: 'dv', antd: null },
    el: { moment: 'el', antd: 'el_GR' },
    'en-au': { moment: 'en-au', antd: 'en_US' },
    'en-ca': { moment: 'en-ca', antd: 'en_US' },
    'en-gb': { moment: 'en-gb', antd: 'en_GB' },
    'en-ie': { moment: 'en-ie', antd: 'en_GB' },
    'en-il': { moment: 'en-il', antd: 'en_US' },
    'en-in': { moment: 'en-in', antd: 'en_US' },
    'en-nz': { moment: 'en-nz', antd: 'en_US' },
    'en-sg': { moment: 'en-sg', antd: 'en_US' },
    eo: { moment: 'eo', antd: null },
    es: { moment: 'es', antd: 'es_ES' },
    'es-do': { moment: 'es-do', antd: 'es_ES' },
    'es-mx': { moment: 'es-mx', antd: 'es_ES' },
    'es-us': { moment: 'es-us', antd: 'es_ES' },
    et: { moment: 'et', antd: 'et_EE' },
    eu: { moment: 'eu', antd: null },
    fa: { moment: 'fa', antd: 'fa_IR' },
    fi: { moment: 'fi', antd: 'fi_FI' },
    fil: { moment: 'fil', antd: null },
    fo: { moment: 'fo', antd: null },
    fr: { moment: 'fr', antd: 'fr_FR' },
    'fr-ca': { moment: 'fr-ca', antd: 'fr_CA' },
    'fr-ch': { moment: 'fr-ch', antd: 'fr_FR' },
    fy: { moment: 'fy', antd: null },
    ga: { moment: 'ga', antd: 'ga_IE' },
    gd: { moment: 'gd', antd: null },
    gl: { moment: 'gl', antd: 'gl_ES' },
    'gom-deva': { moment: 'gom-deva', antd: null },
    'gom-latn': { moment: 'gom-latn', antd: null },
    gu: { moment: 'gu', antd: null },
    he: { moment: 'he', antd: 'he_IL' },
    hi: { moment: 'hi', antd: 'hi_IN' },
    hr: { moment: 'hr', antd: 'hr_HR' },
    hu: { moment: 'hu', antd: 'hu_HU' },
    'hy-am': { moment: 'hy-am', antd: 'hy_AM' },
    id: { moment: 'id', antd: 'id_ID' },
    is: { moment: 'is', antd: 'is_IS' },
    it: { moment: 'it', antd: 'it_IT' },
    'it-ch': { moment: 'it-ch', antd: 'it_IT' },
    ja: { moment: 'ja', antd: 'ja_JP' },
    jv: { moment: 'jv', antd: null },
    ka: { moment: 'ka', antd: 'ka_GE' },
    kk: { moment: 'kk', antd: 'kk_KZ' },
    km: { moment: 'km', antd: 'km_KH' },
    kn: { moment: 'kn', antd: 'kn_IN' },
    ko: { moment: 'ko', antd: 'ko_KR' },
    ku: { moment: 'ku', antd: 'ku_IQ' },
    'ku-kmr': { moment: 'ku-kmr', antd: 'kmr_IQ' },
    ky: { moment: 'ky', antd: null },
    lb: { moment: 'lb', antd: null },
    lo: { moment: 'lo', antd: null },
    lt: { moment: 'lt', antd: 'lt_LT' },
    lv: { moment: 'lv', antd: 'lv_LV' },
    me: { moment: 'me', antd: null },
    mi: { moment: 'mi', antd: null },
    mk: { moment: 'mk', antd: 'mk_MK' },
    ml: { moment: 'ml', antd: 'ml_IN' },
    mn: { moment: 'mn', antd: 'mn_MN' },
    mr: { moment: 'mr', antd: null },
    ms: { moment: 'ms', antd: 'ms_MY' },
    'ms-my': { moment: 'ms-my', antd: 'ms_MY' },
    mt: { moment: 'mt', antd: null },
    my: { moment: 'my', antd: null },
    nb: { moment: 'nb', antd: 'nb_NO' },
    ne: { moment: 'ne', antd: 'ne_NP' },
    nl: { moment: 'nl', antd: 'nl_NL' },
    'nl-be': { moment: 'nl-be', antd: 'nl_BE' },
    nn: { moment: 'nn', antd: 'nb_NO' },
    'oc-lnc': { moment: 'oc-lnc', antd: null },
    'pa-in': { moment: 'pa-in', antd: null },
    pl: { moment: 'pl', antd: 'pl_PL' },
    pt: { moment: 'pt', antd: 'pt_BR' },
    'pt-br': { moment: 'pt-br', antd: 'pt_BR' },
    ro: { moment: 'ro', antd: 'ro_RO' },
    ru: { moment: 'ru', antd: 'ru_RU' },
    sd: { moment: 'sd', antd: null },
    se: { moment: 'se', antd: null },
    si: { moment: 'si', antd: 'si_LK' },
    sk: { moment: 'sk', antd: 'sk_SK' },
    sl: { moment: 'sl', antd: 'sl_SI' },
    sq: { moment: 'sq', antd: null },
    sr: { moment: 'sr', antd: 'sr_RS' },
    'sr-cyrl': { moment: 'sr-cyrl', antd: 'sr_RS' },
    ss: { moment: 'ss', antd: null },
    sv: { moment: 'sv', antd: 'sv_SE' },
    sw: { moment: 'sw', antd: null },
    ta: { moment: 'ta', antd: 'ta_IN' },
    te: { moment: 'te', antd: null },
    tet: { moment: 'tet', antd: null },
    tg: { moment: 'tg', antd: null },
    th: { moment: 'th', antd: 'th_TH' },
    tk: { moment: 'tk', antd: 'tk_TK' },
    'tl-ph': { moment: 'tl-ph', antd: null },
    tlh: { moment: 'tlh', antd: null },
    tr: { moment: 'tr', antd: 'tr_TR' },
    tzl: { moment: 'tzl', antd: null },
    tzm: { moment: 'tzm', antd: null },
    'tzm-latn': { moment: 'tzm-latn', antd: null },
    'ug-cn': { moment: 'ug-cn', antd: null },
    uk: { moment: 'uk', antd: 'uk_UA' },
    ur: { moment: 'ur', antd: 'ur_PK' },
    uz: { moment: 'uz', antd: 'uz_UZ' },
    'uz-latn': { moment: 'uz-latn', antd: 'uz_UZ' },
    vi: { moment: 'vi', antd: 'vi_VN' },
    'x-pseudo': { moment: 'x-pseudo', antd: null },
    yo: { moment: 'yo', antd: null },
    'zh-cn': { moment: 'zh-cn', antd: 'zh_CN' },
    'zh-hk': { moment: 'zh-hk', antd: 'zh_HK' },
    'zh-mo': { moment: 'zh-mo', antd: 'zh_HK' },
    'zh-tw': { moment: 'zh-tw', antd: 'zh_TW' },
};
